import React, { useEffect, useState } from 'react';
import { ProportionalSale } from 'services/actions/proportional_sale';
import { PanelState } from 'store/modules/panel_store/types';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import Api from 'services/api';
import DigitalSignatureSale from 'components/molecules/digital_signature_sale';

const DigitalSignature = () => {
  const [dados, setDados] = useState<object | null>(null);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  useEffect(() => {
    panel?.validate_services?.assinatura_digital
      ? (async () => {
          await Api.get('/digital_signature_documents').then((response: any) => {
            if (response.data.token) {
              window.location.href = `https://conlicitacao.dattasign.com.br/login/${response.data.token}`;
            }
          });
        })()
      : (async () => {
          const request = await ProportionalSale(10, [14]);
          request?.status === 200 && setDados(request?.data);
        })();
  }, []);

  return (
    <div className="page-container">
      {!panel?.validate_services?.assinatura_digital && <DigitalSignatureSale dados={dados} />}
    </div>
  );
};
export default DigitalSignature;
